import { areasTree } from "./areas-tree-screen.js";

export default {
	areasTree
}